module.exports = __webpack_public_path__ + "img/copy.df7d05d7.svg";